// extracted by mini-css-extract-plugin
export default {"component":"r6izZ"};